import CONFIG from '../config.json';
import get from './get.js';
import post from './post.js';

const base = 'api/ama_media';

async function patch(route, json) {
	const response = await fetch(`${CONFIG.api}/${route}`, {
		method: 'PATCH',
		headers: { 'Content-Type': 'application/json' },
		body: JSON.stringify(json),
	});
	let data;
	try {
		data = await response.json();
	} catch (e) {}
	if (response.ok) return data;
	if (response.status === 400) throw data;
	throw 'api_error';
}

async function del(route, query = {}) {
	const q = Object.entries(query).map(([k, v]) => `${k}=${encodeURIComponent(v)}`).join('&');
	const response = await fetch(`${CONFIG.api}/${route}${q ? `?${q}` : ''}`, { method: 'DELETE' });
	let data;
	try {
		data = await response.json();
	} catch (e) {}
	if (response.ok) return data;
	if (response.status === 400) throw data;
	throw 'api_error';
}

export default {
	list: (params) => get(base + '/list', params),
	update_item: (params) => patch(base + '/item', params),
	stopwords_count: (params) => get(base + '/stopwords/count', params),
	stopwords_replace: (params) => post(base + '/stopwords', params),
	schedule_get: (params) => get(base + '/schedule', params),
	schedule_save: (params) => post(base + '/schedule', params),
	schedule_delete: (params) => del(base + '/schedule', params),
	run_scrape: (params) => post(base + '/run_scrape', params || {}),
	stats: (params) => get(base + '/stats', params),
	settings_get: (params) => get(base + '/settings', params),
	settings_save: (params) => patch(base + '/settings', params),
};
